import { DataTableCellProps, TableCell } from 'components/dataTable';

import { formatCryptoAmountWithSymbolAtEnd } from 'utils/cryptoFormatter';

import { RefundAccountTransactionRow } from '../../utils';

export const AmountCell = ({ className, row, column }: DataTableCellProps & { className?: string }) => {
  const transaction = row as RefundAccountTransactionRow;
  const value = transaction[column.id];
  return (
    <TableCell className={className} data-column={column.id} align="right">
      {formatCryptoAmountWithSymbolAtEnd(String(value), transaction.settlementCurrencyCode, {
        precision: 2,
        trimTrailingZeros: false,
      })}
    </TableCell>
  );
};
